import React from 'react';
import { WithPermissions, MenuItemLink } from "react-admin";

import users from "../../users";
import locations from "../../locations";
import coins from "../../coins";
import transactions from "../../transactions";
import fundings from "../../fundings";
import statements from "../../statements";
import SubMenu from "../SubMenu";
import reports from "../../reports";
import payment_method from "../../payment-method";
import app_versions from "../../app-version";
import discount_codes from "../../discount-code";

import FileIcon from "@material-ui/icons/InsertDriveFile";
import BusinessIcon from "@material-ui/icons/Business";
import accounts from "../../accounts";
import ambassador from "../../ambassador";
import AmbassadorIcon from '@material-ui/icons/Business';

// Admin  menu
export const AdminSideMenu = ({ handleToggle, menuBusiness, menuDocs, menuCatalog, open, translate, onMenuClick }) => (
    <WithPermissions
        render={({ permissions }) => (
            permissions === 'system_admin'
                ? <>
                    <MenuItemLink
                        to={`/accounts`}
                        primaryText={translate(`resources.accounts.name`, {
                            smart_count: 2
                        })}
                        leftIcon={<accounts.icon />}
                        onClick={onMenuClick}
                    />
                    <MenuItemLink
                        to={`/fundings`}
                        primaryText={translate(`resources.fundings.name`, {
                            smart_count: 2
                        })}
                        leftIcon={<fundings.icon />}
                        onClick={onMenuClick}
                    />
                    <MenuItemLink
                        to={`/system/paymentmethods`}
                        primaryText={translate(`resources.payment_method.name`, {
                            smart_count: 2
                        })}
                        leftIcon={<payment_method.icon />}
                        onClick={onMenuClick}
                    />
                    <MenuItemLink
                        to={`/system/appversions`}
                        primaryText={translate(`resources.app_versions.name`)}
                        leftIcon={<app_versions.icon />}
                        onClick={onMenuClick}
                    />
                    <MenuItemLink
                        to={`/discount/codes`}
                        primaryText={translate(`resources.discount_codes.name`)}
                        leftIcon={<discount_codes.icon />}
                        onClick={onMenuClick}
                    />
                    <SubMenu
                        handleToggle={() => handleToggle("menuBusiness")}
                        isOpen={menuBusiness}
                        sidebarIsOpen={open}
                        name="pos.menu.ambassador"
                        icon={<ambassador.icon />}
                    >
                        <MenuItemLink
                            to={`/user/ambassador/posts`}
                            primaryText={translate(`resources.posts.name`)}
                                leftIcon={<ambassador.postIcon />}
                                onClick={onMenuClick}
                        />
                        <MenuItemLink
                            to={`/user/ambassador/commissions`}
                            primaryText={translate(`resources.commissions.name`)}
                            leftIcon={<ambassador.commissionIcon />}
                            onClick={onMenuClick}
                        />
                    </SubMenu>
                    
                    <MenuItemLink
                        to={`/transactions`}
                        primaryText={translate(`resources.transactions.name`, {
                            smart_count: 2
                        })}
                        leftIcon={<transactions.icon/>}
                        onClick={onMenuClick}
                    />
                    {/*
                    <SubMenu
                        handleToggle={() => handleToggle("menuDocs")}
                        isOpen={menuDocs}
                        sidebarIsOpen={open}
                        name="pos.menu.docs"
                        icon={<FileIcon />}
                    >
                        <MenuItemLink
                            to={`/reports`}
                            primaryText={translate(`resources.reports.name`, {
                                smart_count: 2
                            })}
                            leftIcon={<reports.icon />}
                            onClick={onMenuClick}
                        />
                        <MenuItemLink
                            to={`/statements`}
                            primaryText={translate(`resources.statements.name`, {
                                smart_count: 2
                            })}
                            leftIcon={<statements.icon />}
                            onClick={onMenuClick}
                        />
                    </SubMenu>
                    */}
                </>
                : null
        )}
    >
    </WithPermissions>
)